import http from "../../http-common";

class CabService {

    create(data) {
        return http.post(`/user/addCab`, data);
    }

    get(data) {
        return http.post(`/user/cabBooking`, data);
    }

    getLeaderMail(data) {
        return http.post(`/user/getLeaderMailId`, data);
    }

}

export default new CabService();